import * as React from 'react';
import ProgressCard from '../cards/ProgressCard';

export interface ProgressPageProps {
    loadingText: string;
    onComponentDidMount: (url: string ) => void;
}

class ProgressPage extends React.Component<ProgressPageProps> {
    render() {
        return (
            <div>
                <div className="row">&nbsp;</div>
                <div className="row">
                    <ProgressCard progressText={this.props.loadingText}/>
                </div>
            </div>
        );
    }
    componentDidMount() {
        const url: string = window.location.href;        
        this.props.onComponentDidMount(url);
    }
}

export default ProgressPage;



// WEBPACK FOOTER //
// ./src/components/callback/ProgressPage.tsx